import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  hideFooter = new Subject<boolean>();
  baseUrl = 'https://www.skyaccess.eu/integraApaleoAPI/';

  constructor(private http: HttpClient) { }
  

  testEndpoint() {
    return this.http.get('https://httpbin.org/get');
  }

  CardChecking(body) {
    return this.http.post(this.baseUrl + 'api/reservation/CardChecking', body);
  }

  GetReservationByReservationID(reservationId) {
    return this.http.get(this.baseUrl + 'api/reservation/GetReservation/' + reservationId);
  }
}
